import React from "react";
import styled from "styled-components";
import {
  FROM_X_TO_Y_PROMOTION,
  TAKE_X_PAY_Y_PROMOTION,
  VAREJO_ATACADO_PROMOTION,
} from "../../../CanvasViewer/EncarteConstants";
import { Container, PromoPriceWrapper } from "./PriceShared.styles";
import { getPriceFontSize } from "./Price.utils";
import { MainPriceDisplay } from "./MainPriceDisplay";
import { TakeXPayYPromotion } from "./TakeXPayYPromotion";
import { FromXToYPromotion } from "./FromXToYPromotion";
import { VarejoAtacadoPromotion } from "./VarejoAtacadoPromotion";

export { getPriceFontSize };

// Backward-compatible named export used by legacy imports.
export const PriceContentWrapper = styled.div``;

const isTakeXPayY = (product) =>
  product.promotionType === TAKE_X_PAY_Y_PROMOTION;
const isFromXToY = (product) => product.promotionType === FROM_X_TO_Y_PROMOTION;
const isVarejoAtacado = (product) =>
  product.promotionType === VAREJO_ATACADO_PROMOTION;

export default function MainPriceComponent({
  product,
  unity,
  styles,
  position,
  canvasScale,
  className = "",
  commonMultiplier = 1,
}) {
  if (!product) return null;
  const priceStr = String(
    (isVarejoAtacado(product) && product.varejoPrice) ||
      product.promotionPrice ||
      product.price ||
      "",
  );
  const imageUrl = styles.priceStyleTmp;

  return (
    <Container
      className={`price flex justify-center align CONTAINER ${className}`}
    >
      <PromoPriceWrapper
        styles={styles}
        className={`${className || ""} flex`}
        canvasScale={canvasScale}
        length={priceStr.length}
        commonMultiplier={commonMultiplier}
      >
        {isTakeXPayY(product) && (
          <TakeXPayYPromotion
            product={product}
            styles={styles}
            canvasScale={canvasScale}
            className={className}
          />
        )}

        {isFromXToY(product) && (
          <FromXToYPromotion
            product={product}
            styles={styles}
            canvasScale={canvasScale}
            className={className}
            position={position}
            length={priceStr.length}
            imageUrl={imageUrl}
            commonMultiplier={commonMultiplier}
            unity={unity}
          />
        )}

        {isVarejoAtacado(product) && (
          <VarejoAtacadoPromotion
            product={product}
            styles={styles}
            canvasScale={canvasScale}
            className={className}
          />
        )}

        <MainPriceDisplay
          className={className}
          canvasScale={canvasScale}
          styles={styles}
          position={position}
          length={priceStr.length}
          imageUrl={imageUrl}
          commonMultiplier={commonMultiplier}
          price={priceStr}
          unity={unity}
        />
      </PromoPriceWrapper>
    </Container>
  );
}
